import { DataAnnotationStatus } from '@robovision/data'
import type { HubAnnotationStatus } from '@robovision/hub'
import { AnnotationStatus } from '~domain/filtering/AnnotationStatus'
import type { SelectedFilters } from '~domain/filtering/SelectedFilters'


const ANNOTATION_STATUS_MAP: Record<AnnotationStatus, DataAnnotationStatus[]> = {
  [AnnotationStatus.Annotated]: [DataAnnotationStatus.COMPLETE, DataAnnotationStatus.PARTIAL],
  [AnnotationStatus.NotAnnotated]: [DataAnnotationStatus.NONE],
  [AnnotationStatus.EmptyAnnotation]: [],
}

export interface FiltersQueryLike {
  annotationCounts?: string[][]
  annotationSourceIds?: string[][]
  annotationStatuses?: DataAnnotationStatus[] | HubAnnotationStatus[]
  classIds?: string[][]
  descriptions?: string[][]
  embeddingNames?: string[][]
  metadata?: Record<string, unknown>[]
  sampleIds?: string[]
  setIds?: string[][]
  tagIds?: string[][]
  unionType: 'INTERSECT' | 'EXCEPT'
}

interface IntersectionQueryLike {
  filters: FiltersQueryLike[]
}

export function filtersToQuery (filters?: Partial<SelectedFilters>): FiltersQueryLike {
  return {
    annotationCounts: filters?.annotationStatus?.size === 1 &&
      filters?.annotationStatus.has(AnnotationStatus.EmptyAnnotation)
      ? [['0']]
      : undefined,
    annotationSourceIds: filters?.users?.size
      ? [[...filters.users]]
      : undefined,
    annotationStatuses: filters?.annotationStatus?.size
      ? [...filters.annotationStatus].map(s => ANNOTATION_STATUS_MAP[s as AnnotationStatus]).flat()
      : undefined,
    classIds: filters?.classes?.size
      ? [[...filters.classes]]
      : undefined,
    embeddingNames: filters?.embeddedNames?.size
      ? [[...filters?.embeddedNames]]
      : undefined,
    sampleIds: filters?.sampleIds?.size
      ? [...filters.sampleIds]
      : undefined,
    tagIds: filters?.tags?.size || filters?.imports?.size
      ? [
        ...(filters?.tags?.size ? [[...filters.tags]] : []),
        ...(filters?.imports?.size ? [[...filters.imports]] : []),
      ]
      : undefined,
    unionType: 'INTERSECT',
  }
}

export function filtersToIntersectionQuery (filters?: Partial<SelectedFilters>): IntersectionQueryLike {
  return {
    filters: [filtersToQuery(filters)],
  }
}
